import React from "react";
import { Grid, Button } from "../../components";
import { COLOR } from "../../theme/constants";

var ScrollToSection = function ScrollToSection(_a) {
  var onClick = _a.onClick,
      text = _a.text;
  return React.createElement(Grid.Container, {
    display: "flex",
    fluid: true,
    justifyContent: "center",
    p: 4,
    background: COLOR.lightGrey
  }, React.createElement(Button, {
    onClick: onClick,
    isPrimary: true
  }, text));
};

export default ScrollToSection;